import { Resource } from '../i18n';

export const it: Resource = {
  misc: {
    storeName: 'Sergio Rossi',
  },
  welcome: 'Benvenuto su store-sergiorossi!',
};
